import React from 'react';

// TODO: provide more options for different type of pages.
export function ProgressiveLoadingBlock() {
  return (
    <React.Fragment>
      <div
        className="progressive-loading-block"
        style={{
          margin: '32px 32px 16px 15px',
          backgroundColor: '#f3f2f1',
          minHeight: '220px',
          width: 'calc(100%-64)',
        }
      }
      />
      <div style={{
        minHeight: '68px',
      }}
      >
        <div style={{
          margin: '8px 32px 16px 15px',
          backgroundColor: '#f3f2f1',
          minHeight: '50px',
          width: '50%',
          display: 'inline-block',
          float: 'left',
        }}
        />
        <div style={{
          margin: '8px 32px 16px 16px',
          backgroundColor: '#f3f2f1',
          minHeight: '50px',
          width: '10%',
          display: 'inline-block',
          float: 'right',
        }}
        />
        <div style={{
          margin: '8px 32px 16px 16px',
          backgroundColor: '#f3f2f1',
          minHeight: '50px',
          width: '10%',
          display: 'inline-block',
          float: 'right',
        }}
        />
      </div>
      <div style={{
        margin: '8px 32px 16px 15px',
        backgroundColor: '#f3f2f1',
        minHeight: '420px',
        width: 'calc(100%-64)',
        display: 'block',
      }}
      />
    </React.Fragment>
  );
}
